import React from 'react'
import {Body} from './body'
import {Cell} from './cell'
import {Footer} from './footer'
import {Header} from './header'
import {Row} from './row'
import {Title} from './title'

interface Props {
  children?: React.ReactNode
}

const TableComponent = (props: Props) => {
  const {children} = props
  return <table className="w-full table-fixed min-w-1400">{children}</table>
}

export const Table = Object.assign(TableComponent, {
  Cell,
  Footer,
  Header,
  Body,
  Row,
  Title
})
